<template>
  <div style="padding-top: 150px">
    <!-- 导航 -->
    <mynav></mynav>
    <div class="content">
      <img :src="coverurl" alt="" width="100%" style="margin-bottom: 60px" />
      <div
        v-for="(item, index) in dataList"
        :key="index"
        class="content-item"
        :class="index % 2 != 0 ? 'mycolor' : ''"
      >
        <div class="item-inner" v-if="index % 2 == 0">
          <div class="item-banner">
            <el-carousel :height="imgHieght" arrow="always" :interval="5000">
              <el-carousel-item v-if="item.urlone">
                <img
                  :src="item.urlone"
                  alt=""
                  width="100%"
                  ref="image"
                  @load="imgLoad"
                />
              </el-carousel-item>
              <el-carousel-item v-if="item.urltwo">
                <img
                  :src="item.urltwo"
                  alt=""
                  width="100%"
                  ref="image"
                  @load="imgLoad"
                />
              </el-carousel-item>
              <el-carousel-item v-if="item.urlthree">
                <img
                  :src="item.urlthree"
                  alt=""
                  width="100%"
                  ref="image"
                  @load="imgLoad"
                />
              </el-carousel-item>
              <el-carousel-item v-if="item.urlfour">
                <img
                  :src="item.urlfour"
                  alt=""
                  width="100%"
                  ref="image"
                  @load="imgLoad"
                />
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="item-content">
            <div class="item-title">
              {{ item.title }}
            </div>
            <div
              v-html="item.content"
              ref="content"
              :style="{ height: contentHeight }"
              style="overflow-y: hidden"
            ></div>
            <div
              class="more"
              @click="mymore(item.id)"
              ref="more"
              style="display: block"
            >
              MORE>>
            </div>
          </div>
        </div>
        <div class="item-inner" v-else>
          <div class="item-content">
            <div class="item-title">
              {{ item.title }}
            </div>
            <div
              v-html="item.content"
              ref="content"
              :style="{ height: contentHeight }"
              style="overflow-y: hidden"
            ></div>
            <div
              class="more"
              @click="mymore(item.id)"
              ref="more"
              style="display: block"
            >
              MORE>>
            </div>
          </div>
          <div class="item-banner">
            <el-carousel :height="imgHieght" arrow="always" :interval="5000">
              <el-carousel-item v-if="item.urlone">
                <img
                  :src="item.urlone"
                  alt=""
                  width="100%"
                  ref="image"
                  @load="imgLoad"
                />
              </el-carousel-item>
              <el-carousel-item v-if="item.urltwo">
                <img
                  :src="item.urltwo"
                  alt=""
                  width="100%"
                  ref="image"
                  @load="imgLoad"
                />
              </el-carousel-item>
              <el-carousel-item v-if="item.urlthree">
                <img
                  :src="item.urlthree"
                  alt=""
                  width="100%"
                  ref="image"
                  @load="imgLoad"
                />
              </el-carousel-item>
              <el-carousel-item v-if="item.urlfour">
                <img
                  :src="item.urlfour"
                  alt=""
                  width="100%"
                  ref="image"
                  @load="imgLoad"
                />
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
      <div class="fen">
        <div class="fen-inner">
          <div @click="myload('up')">上一页</div>
          <div>{{ pageNumber }}/{{ page }}</div>
          <div @click="myload('next')">下一页</div>
        </div>
      </div>
    </div>

    <div style="padding-top: 40px">
      <myfooter></myfooter>
    </div>
  </div>
</template>
<script>
import mynav from "../../components/nav.vue";
import myfooter from "../../components/footer.vue";
import "../../assets/css/amazeui.min.css";
export default {
  data() {
    return {
      id: "",
      coverurl: "",
      imgHieght: "300px",
      contentHeight: "",
      dataList: "",
      pageNumber: 1,
      total: "",
      page: "",
      lab: "",
    };
  },

  components: {
    mynav,
    myfooter,
  },
  watch: {
    $route() {
      this.id = this.$route.params.type;
      this.lab = this.$route.query.lab || "ALL";
      this.myload();
    },
  },
  created() {
    this.id = this.$route.params.type;
    this.lab = this.$route.query.lab || "ALL";
    this.myload();
  },
  mounted() {
    window.onresize = () => {
      this.imgLoad();
    };
  },
  methods: {
    myload(type) {
      if (type == "up") {
        if (this.pageNumber != 1) {
          this.pageNumber = this.pageNumber - 1;
        }
      }
      if (type == "next") {
        if (this.pageNumber != this.page) {
          this.pageNumber = this.pageNumber + 1;
        }
      }
      this.$axios.get(`/front/getFrontPhone?type=${this.id}`).then((res) => {
        this.coverurl = res.data.url;
      });
      this.$axios
        .get(
          `/front/getFrontCaseArtList?type=${this.id}&pageSize=10&pageNumber=${this.pageNumber}&lab=${this.lab}`
        )
        .then((res) => {
          this.dataList = res.data.list;
          this.pageNumber = res.data.pageNumber;
          this.total = res.data.totalRow;
          this.page = res.data.totalPage;
        });
    },
    imgLoad() {
      this.$nextTick(() => {
        if (this.$refs.image[0]) {
          this.imgHieght = this.$refs.image[0].height + "px";
          this.contentHeight = this.$refs.image[0].height - 80 + "px";
        }
      });
      let mynode = document.getElementsByTagName("img");
      for (const iterator of mynode) {
        if (iterator.parentNode.tagName != "DIV") {
          iterator.style.display = "none";
        }
      }
    },
    mymore(id) {
      this.$router.push("/details/" + id + "?type=" + this.id);
    },
  },
};
</script>
<style scoped lang="less">
.content {
  width: 100%;
  .content-item {
    width: 100%;
    .item-inner {
      width: 1200px;
      margin: 60px auto;
      display: flex;
      padding: 80px 15px;
      box-sizing: border-box;
      justify-content: space-between;
      .item-banner {
        width: 40%;
      }
      .item-content {
        width: 50%;
        .item-title {
          line-height: 30px;
          letter-spacing: 2px;
          font-size: 2.8rem;
          margin-bottom: 16px;
        }
        .more {
          color: #acc737;
          text-align: right;
          width: 100%;
          cursor: pointer;
        }
        .button {
          justify-content: center;
          width: 100%;
          div {
            color: #444;
            background-color: #e6e6e6;
            border-color: #e6e6e6;
            width: 70px;
            line-height: 30px;
            text-align: center;
            cursor: pointer;
            margin-top: 10px;
          }
        }
      }
    }
  }
  .fen {
    display: flex;
    justify-content: center;
    .fen-inner {
      display: flex;
      justify-content: space-between;
      width: 500px;
      div {
        color: #444;
        background-color: #e6e6e6;
        border-color: #e6e6e6;
        width: 70px;
        line-height: 30px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
  .mycolor {
    background-color: #eaeaea;
  }
}
@media only screen and (max-width: 1200px) {
  .content {
    .content-item {
      .item-inner {
        width: 100%;
      }
    }
  }
}
@media only screen and (max-width: 641px) {
  .content {
    .content-item {
      .item-inner {
        display: block;
        .item-banner {
          width: 100%;
        }
        .item-content {
          width: 100%;
          margin-top: 40px;
        }
      }
    }
  }
}
</style>